import { useState, MouseEvent } from 'react'
import moment from 'moment-timezone'

import { Graph } from './graph'
import { TimeframeButtons } from './timeframe-buttons.component'

import useStyles from './styles'
import { EPOCH_TIME_MS } from 'src/constants'
import { useAccountViews, useMe } from 'src/hooks'
import { GlobalStatistic } from '../global-statistic'

const loadData = [
  { timeframe: '', views: 0 },
  { timeframe: '', views: 0 },
]

const DashboardGraph = () => {
  const [timeframe, setTimeframe] = useState(EPOCH_TIME_MS.ONE_MONTH)
  const classes = useStyles()
  const { data: user, isFetching: isFetchingUser } = useMe()
  const { data, isFetching } = useAccountViews(timeframe)

  const hanldeTimeframeChange = (_: MouseEvent, val: number) => {
    if (val === null) return
    setTimeframe(val)
  }

  let convertedData = null

  if (
    user?.timezone &&
    data?.data &&
    timeframe === EPOCH_TIME_MS.ONE_DAY &&
    !isFetchingUser &&
    !isFetching
  ) {
    convertedData = data?.data.map((item) => ({
      ...item,
      timeframe: moment
        .utc(item.timeframe, 'HH:mm')
        .tz(user?.timezone ?? 'UTC')
        .format('HH:mm'),
    }))
  }

  const graphData =
    isFetching && !data?.data ? loadData : convertedData ? convertedData : data?.data || []

  return (
    <div className={classes.container}>
      <div className={classes.graphWrapper}>
        <Graph data={graphData} />
      </div>
      <div className={classes.timeframeWrapper}>
        <div className={classes.statsWrapper}>
          <GlobalStatistic timeframe={timeframe} />
        </div>
        <TimeframeButtons timeframe={timeframe} handleTimeframeChange={hanldeTimeframeChange} />
      </div>
    </div>
  )
}

export { DashboardGraph }
